// 应用分类列表
export const applicationClassifyList = state => state.applicationClassifyList
// 所有菜单
export const allMenu = state => state.allMenu
// 页面框架
export const pageFrame = state => state.pageFrame
// 非商城按钮名称
export function nonCatalogNameLabel (state) {
  const lang = window.fe.language
  return state.nonCatalogName[lang]
}
